import { getIncomePeriods } from "../../utils/incomePeriods";
import { chargeMonthKey, formatMonthKey } from "./chargeDates";
import {
  getIncomePeriodStartMonthKey,
  monthKeyFromDate,
} from "./incomePeriod";

const currentCalendarMonthKey = (today = new Date()) =>
  `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}`;

export const canOverrideClosedChargeMonths = (permissions = []) =>
  (Array.isArray(permissions) ? permissions : []).some(
    (permission) =>
      ["administrator", "finance admin"].includes(
        String(permission || "").trim().toLowerCase(),
      ),
  );

export const getOpenChargeMonth = (
  periods = [],
  fallbackOpenMonth = currentCalendarMonthKey(),
) => {
  const periodEndMonths = periods
    .map((period) =>
      monthKeyFromDate(
        period.endDatetime ||
          period.endDate ||
          period.incomePeriodEndDatetime,
      ),
    )
    .filter(Boolean)
    .sort((left, right) => right.localeCompare(left));
  return periodEndMonths[0] || fallbackOpenMonth;
};

export const getClosedChargeMonths = (periods = []) =>
  new Set(periods.map(getIncomePeriodStartMonthKey).filter(Boolean));

export const isChargeMonthClosed = (
  periods,
  month,
  fallbackOpenMonth = currentCalendarMonthKey(),
) => {
  if (!month) return false;
  if (getClosedChargeMonths(periods).has(month)) return true;
  const openMonth = getOpenChargeMonth(periods, fallbackOpenMonth);
  return Boolean(openMonth && month < openMonth);
};

export const assertChargeDatesAreOpen = async (
  dates = [],
  { loadIncomePeriods = getIncomePeriods } = {},
) => {
  const months = [...new Set(dates.map(chargeMonthKey).filter(Boolean))];
  if (!months.length) return;

  let periods;
  try {
    periods = await loadIncomePeriods();
  } catch (error) {
    throw new Error(
      "The charge could not be changed because the month status could not be verified.",
    );
  }

  const closedMonth = months.find((month) =>
    isChargeMonthClosed(periods, month),
  );
  if (closedMonth) {
    throw new Error(
      `${formatMonthKey(closedMonth)} has been closed. Please change the date to an open month.`,
    );
  }
};
